/* ============================================================
   cart-redact.js — strip the print-ready URL from cart properties
   ============================================================
   The editor app (night-sky-es-prod) currently adds the line-item
   property `__generatedPosterURL`, which points to a publicly
   readable S3 object that IS the final HD print file. Anyone
   calling /cart.js can read the URL and download the file without
   paying. This script runs on every storefront page and, if any
   line item still carries that property, calls /cart/change.js to
   remove it.

   Kept intact:
     - __thumbnailURL — low-res preview the cart needs to display.
     - __posterUUID, __productType — fulfillment looks up the
       print master server-side using the UUID; no URL needed in
       the line item.

   THIS IS A WORKAROUND. The real fix lives in the editor backend:
     · S3 bucket must be private.
     · Print master served via signed URL + short TTL, only after
       payment is confirmed.
     · Editor must not include any print-master URL in the line
       item properties at all.
   ============================================================ */
(function () {
  'use strict';

  // Keys whose VALUE looks like a print-master URL and should be
  // removed from cart line items.
  var REDACT_KEYS = ['__generatedPosterURL'];

  function looksLikeUrl(v) {
    return typeof v === 'string' && /^https?:\/\//.test(v);
  }

  function run() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

        var targets = [];
        cart.items.forEach(function (item, idx) {
          var props = item.properties || {};
          var hit = REDACT_KEYS.some(function (k) { return looksLikeUrl(props[k]); });
          if (hit) targets.push({ line: idx + 1, props: props });
        });
        if (targets.length === 0) return;

        // Strip in series — Shopify's cart endpoint doesn't support concurrent writes.
        targets.reduce(function (chain, t) {
          return chain.then(function () {
            var newProps = {};
            Object.keys(t.props).forEach(function (k) {
              if (REDACT_KEYS.indexOf(k) === -1) newProps[k] = t.props[k];
            });
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ line: t.line, properties: newProps })
            }).catch(function (e) {
              console.warn('[cart-redact] line', t.line, 'failed:', e);
            });
          });
        }, Promise.resolve()).then(function () {
          document.dispatchEvent(new CustomEvent('cart:redacted'));
        });
      })
      .catch(function () { /* swallow — best-effort */ });
  }

  // Run after first paint so we don't block initial render.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 2000 });
  } else {
    setTimeout(run, 100);
  }
})();
